/* eslint-disable max-len */
import React from 'react';

export function EnvelopeQuestionMark(): JSX.Element {
  return (
    <svg width='40' height='37' viewBox='0 0 40 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4 23L13 14' stroke='#153F66' strokeWidth='2' strokeLinecap='round' />
      <path d='M36 23L27 14' stroke='#153F66' strokeWidth='2' strokeLinecap='round' />
      <path
        d='M4 4.5L18.94 13.8375C19.5885 14.2428 20.4115 14.2428 21.06 13.8375L36 4.5'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <circle cx='20' cy='28' r='8' stroke='#153F66' strokeWidth='2' />
      <path
        d='M3 0C1.34315 0 0 1.34315 0 3V24C0 25.6569 1.34314 27 3 27H11.0549C11.1316 26.3065 11.287 25.6368 11.5121 25H3C2.44771 25 2 24.5523 2 24V3C2 2.44772 2.44772 2 3 2H37C37.5523 2 38 2.44771 38 3V24C38 24.5523 37.5523 25 37 25H28.4879C28.713 25.6368 28.8684 26.3065 28.9451 27H37C38.6569 27 40 25.6569 40 24V3C40 1.34315 38.6569 0 37 0H3Z'
        fill='#153F66'
      />
      <path
        d='M19.1123 29.8843H20.6458C20.5704 28.3005 23.1095 28.5393 23.1095 26.2265C23.1095 24.7055 21.9531 23.7 20.2059 23.7C18.3958 23.7 17.2394 24.8061 17.3022 26.4779L18.8106 26.6287C18.7352 25.686 19.2883 25.0701 20.2059 25.0701C20.9601 25.0701 21.4629 25.5477 21.4629 26.2391C21.4629 27.7977 18.9363 27.6217 19.1123 29.8843ZM19.9419 32.7C20.5076 32.7 20.9224 32.2851 20.9224 31.7321C20.9224 31.179 20.5076 30.7642 19.9419 30.7642C19.3888 30.7642 18.9615 31.179 18.9615 31.7321C18.9615 32.2851 19.3888 32.7 19.9419 32.7Z'
        fill='#FF3E51'
      />
    </svg>
  );
}
